S.stickyCta = {
    elements: {
        $button: null,
        $social: null,
    },

    init()
    {
        this.elements.$button.on('click', () =>
        {
            if (S.mq('desktop', false).matches || S.mq('tablet', false).matches)
            {
                this.toggleDesktop();
            }
            else
            {
                this.toggleMobile();
            }
        });
    },

    toggleDesktop()
    {
        if (this.elements.$button.hasClass('is-closed'))
        {
            this.elements.$social.animate({'margin-right': '0'});
            this.elements.$social.show();
            this.elements.$button.removeClass('is-closed');
        }
        else
        {
            this.elements.$social.animate({'margin-right': '-=' + this.elements.$social.width()});
            this.elements.$social.fadeOut('fast');
            this.elements.$button.addClass('is-closed');
        }
    },

    toggleMobile()
    {
        if (this.elements.$button.hasClass('is-closed'))
        {
            this.elements.$social.parent().animate({width: '+=' + this.elements.$social.width()});
            this.elements.$social.css('margin-right', '0');
            this.elements.$social.show();
            this.elements.$button.removeClass('is-closed');
        }
        else
        {
            this.elements.$social.css('margin-right', '0');
            this.elements.$social.parent().animate({width: '-=' + this.elements.$social.width()});
            this.elements.$social.fadeOut();
            this.elements.$button.addClass('is-closed');
        }
    },

};
